import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIllustrationWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 51,
	viewBox: "0 0 56 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_f_50090_6181)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M26.4617 9.16674C27.3598 7.61119 29.605 7.61119 30.5031 9.16675L46.8175 37.4241C47.7156 38.9796 46.593 40.9241 44.7968 40.9241H12.168C10.3718 40.9241 9.24922 38.9796 10.1473 37.4241L26.4617 9.16674Z",
				fill: "url(#paint0_linear_50090_6181)"
			})
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -12.7991,
			y: .611328,
			width: 63.7869,
			height: 59.6118,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(7px)",
					clipPath: "url(#bgblur_0_50090_6181_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_ii_50090_6181)",
			"data-figma-bg-blur-radius": 14,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M17.0736 15.7781C17.9717 14.2225 20.217 14.2225 21.1151 15.7781L36.6718 42.7231C37.5699 44.2786 36.4473 46.2231 34.6511 46.2231H3.53765C1.74145 46.2231 0.618826 44.2786 1.51693 42.7231L17.0736 15.7781Z",
				fill: "#F8CE98",
				fillOpacity: .5
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4151 33.2809C17.4151 33.9022 17.9188 34.4059 18.5401 34.4059C19.1614 34.4059 19.6651 33.9022 19.6651 33.2809L19.6651 25.0625C19.6651 24.4412 19.1614 23.9375 18.5401 23.9375C17.9188 23.9375 17.4151 24.4412 17.4151 25.0625L17.4151 33.2809Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8501 37.7188C16.8501 38.6507 17.6069 39.4062 18.5388 39.4062C19.4708 39.4062 20.2276 38.6507 20.2276 37.7188C20.2276 36.7868 19.4708 36.0312 18.5388 36.0312C17.6069 36.0312 16.8501 36.7868 16.8501 37.7188Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_f_50090_6181",
				x: 1.83105,
				y: 0,
				width: 53.3027,
				height: 48.9241,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 4,
						result: "effect1_foregroundBlur_50090_6181"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_ii_50090_6181",
				x: -12.7991,
				y: .611328,
				width: 63.7869,
				height: 59.6118,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: -4 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect1_innerShadow_50090_6181"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 2,
						dy: 4
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_innerShadow_50090_6181",
						result: "effect2_innerShadow_50090_6181"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_50090_6181_clip_path",
				transform: "translate(12.7991 -0.611328)",
				children: /* @__PURE__ */ _jsx("path", { d: "M17.0736 15.7781C17.9717 14.2225 20.217 14.2225 21.1151 15.7781L36.6718 42.7231C37.5699 44.2786 36.4473 46.2231 34.6511 46.2231H3.53765C1.74145 46.2231 0.618826 44.2786 1.51693 42.7231L17.0736 15.7781Z" })
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_50090_6181",
				x1: 8.48852,
				y1: 13.1832,
				x2: 51.9873,
				y2: 52.6765,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#BF7109" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E28912"
				})]
			})
		] })
	]
});
export default SvgIllustrationWarning;
